module.exports = __webpack_public_path__ + "static/media/stockhausen_cartagena_8.33746406.jpg";